<template>
  <v-card class="sim-card" variant="flat">
    <v-card-text class="pa-4">
      <div class="d-flex align-center justify-space-between mb-1">
        <div class="title">💳 {{ simName }}</div>
        <v-chip :color="hasNumber ? 'success' : 'grey'" size="small" variant="flat">
          {{ hasNumber ? c.active : c.empty }}
        </v-chip>
      </div>

      <div class="sub" v-if="hasNumber">{{ c.number_now }}: <strong>{{ numberLabel }}</strong></div>
      <div class="sub" v-else>{{ c.no_number }}</div>

      <div class="actions">
        <template v-if="hasNumber">
          <v-btn size="small" color="primary" variant="tonal" disabled>{{ c.change_number }}</v-btn>
          <v-btn size="small" variant="text" disabled>{{ c.details }}</v-btn>
        </template>
        <template v-else>
          <v-btn size="small" color="primary" variant="tonal" disabled>{{ c.activate_number }}</v-btn>
        </template>
        <v-chip size="x-small" color="warning" variant="tonal" class="ml-auto">{{ c.soon }}</v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';
import { cc } from "@/views/client/clientCopy";

export default defineComponent({
  name: 'SimCard',
  props: { item: { type: Object, required: true } },
  computed: {
    c() { return cc(); },
    simName() {
      const serial = this.item.serial || this.item.iccid || this.item.id;
      return 'SIM ····' + String(serial || '').slice(-4);
    },
    hasNumber() { return !!(this.item.msisdn || this.item.msisdn_number || this.item.number); },
    numberLabel() { return this.item.msisdn || this.item.msisdn_number || this.item.number; },
  },
});
</script>

<style scoped>
.sim-card { border: 1px solid #E6E9F0; border-radius: 16px; box-shadow: 0 1px 3px rgba(20,30,60,.06); }
.title { font-size: 1.05rem; font-weight: 800; color: #1a2233; }
.sub { color: #5A6275; font-size: .92rem; }
.actions { display: flex; align-items: center; gap: 8px; margin-top: 14px; flex-wrap: wrap; }
</style>
